import React from 'react'
import styles from './index.module.less'
//import { useNavigate } from 'react-router-dom'
const url = 'https://hyhzimfg-1316759422.cos.ap-shanghai.myqcloud.com/assets/imgs/guests/'
const data = [
  { id: 1, name: 'Susanne Lehmann', post: '物流执行总监', firm: '上汽大众', img: url + 'g1.jpg' },
  { id: 2, name: '郭永强', post: '亚太区工业总监', firm: '索尔维投资有限公司', img: url + 'g2.jpg' },
  { id: 3, name: '慕斌', post: '资深技术专家', firm: '', img: url + 'g3.jpg' },
  { id: 4, name: 'Keith Hoover', post: '总裁', firm: '索尔维投资有限公司', img: url + 'g4.jpg' },
  { id: 5, name: '朱赛春', post: '智能网联高级技术总监', firm: '广汽蔚来新能源科技有限公司', img: url + 'g5.jpg' },
  { id: 6, name: '袁俊荣', post: '亚太IT总监', firm: '李尔（中国）投资有限公司', img: url + 'g6.jpg' },
  { id: 7, name: '王祥', post: '执行会长', firm: '上海交大EMBA汽车协会', img: url + 'g7.jpg' },
  { id: 8, name: '王蓓', post: '摩斯系统副总裁兼亚洲区总经理', firm: '博格华纳', img: url + 'g8.jpg' },
  { id: 9, name: 'Ralf Schieder', post: '战略与物流部副总裁', firm: '华晨宝马', img: url + 'g9.jpg' },
  { id: 10, name: 'Vijay Ganesan', post: '技术战略负责人', firm: 'Stellantis', img: url + 'g10.jpg' },
  { id: 11, name: 'Sarina Sun', post: '助理教授', firm: '香港理工大学', img: url + 'g11.jpg' },
  { id: 12, name: '王春江', post: '数字化事业部副总裁、海克斯康汽车研究院院长', firm: '海克斯康', img: url + 'g12.jpg' },
  { id: 13, name: '于书田', post: '智慧物流部高级经', firm: '吉利汽车', img: url + 'g13.jpg' },
  { id: 14, name: '陈智展', post: '副总经理兼采购总监', firm: '上海加冷松芝汽车空调股份有限公司', img: url + 'g14.jpg' },
  { id: 15, name: '王东', post: '运营副总裁', firm: '苏州沙力医疗器械', img: url + 'g15.jpg' },
  { id: 16, name: '郭瑞军', post: '全球物流服务部亚太首席数据官', firm: '博世', img: url + 'g16.jpg' },
  { id: 17, name: '王波', post: '数字化工程总监', firm: '雅迪科技集团有限公司', img: url + 'g17.jpg' },
  { id: 18, name: '马振山', post: '党委书记，常务副总裁，联合市场销售与服务机构常务副总裁', firm: '奇瑞捷豹路虎', img: url + 'g18.jpg' },
]
export default function Guests() {
  //const navigate = useNavigate()
  // const goDetail = (id) => {
  //   navigate(`/guests/detail?id=${id}`)
  // }
  return (
    <div style={{ backgroundColor: '#F4F9FE' }}>
      <div className={styles.cont}>
        <span className={styles.big_title}>演讲嘉宾</span>
        <div className={styles.guest_area}>
          {
            data.map(i => (
              <div className={styles.item} key={i.id}>
                <div className={styles.left}>
                  <img src={i.img} alt="" />
                </div>
                <div className={styles.right}>
                  <p>{i.name}</p>
                  <p>{i.post}</p>
                  <p>{i.firm}</p>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}
